export default __webpack_public_path__ + "static/media/information--height-limit--g2.28706fba.png";